export const EXECUTOR_ENTITY_TYPES = {
  'any': 'любой',
  legal_entity: 'юр. лицо',
  private_entity: 'физ. лицо'
}
